<div>
    <hub-modal-header headerText="{{ 'bikeshop.modal.update_job_card.quote.create_inventory_item' | translate }}"
        [activeModal]="activeModal"></hub-modal-header>
</div>

<div class="modal-content-container">
    <div class="row margin-top-16">
        <!-- <div class="col-md-4 label" [ngClass]="{'red bold': skuExists}">
            {{ 'bikeshop.products.sku' | translate }}
        </div>
        <div class="col-md-8 value">
            <input id="float-input" type="text" pInputText
                placeholder="{{ 'bikeshop.products.sku_placeholder' | translate }}" [(ngModel)]="product.sku"
                (ngModelChange)="product.sku = $event.toUpperCase()" (keydown)="inputChanged()"
                (focus)="editingSKU = true" (blur)="editingSKU = false" />
            <div class="small" *ngIf="skuExists">{{ 'bikeshop.products.sku_already_taken' | translate }}</div>
        </div> -->
        <div class="col-md-12">
            <hub-input [label]="'bikeshop.products.sku' | translate" [labelColor]="skuExists ? '#f24646' : ''"
                (ngModelChange)="product.sku = $event.toUpperCase()" (input)="inputChanged()"
                placeholder="{{ 'bikeshop.products.sku_placeholder' | translate }}" [autofocus]="true"
                [(ngModel)]="product.sku"></hub-input>
            <div class="small" *ngIf="skuExists">{{ 'bikeshop.products.sku_already_taken' | translate }}</div>
        </div>
    </div>

    <div class="row margin-top-16">
        <div class="col-md-12">
            <hub-input [label]="'bikeshop.products.product_name' | translate"
                [labelColor]="!product.name ? '#f24646' : ''"
                placeholder="{{ 'bikeshop.products.product_name' | translate }}" [(ngModel)]="product.name"></hub-input>
        </div>
    </div>

    <div class="row margin-top-16">
        <div class="col-md-6">
            <div class="jobcard-label"
                [ngStyle]="{color: product.defaultPrice === null || product.defaultPrice === undefined || product.defaultPrice.length === 0 ? '#f24646' : ''}">
                {{ 'bikeshop.products.default_price' | translate }}</div>
            <div class="p-inputgroup">
                <input currencyMask class="p-inputtext" [(ngModel)]="product.defaultPrice" [options]="currencyoptions"
                    placeholder="{{ (vatInclusive ? 'bikeshop.products.incl_vat' : 'bikeshop.products.excl_vat') | translate }}" />
            </div>
        </div>
    </div>
    <div class="row margin-top-16">
        <div class="col-md-12 flex">
            <small>
                ***{{ 'bikeshop.products.tax_explanation' | translate }}
            </small>
        </div>
    </div>

    <div class="row margin-top-16">
        <div class="col-md-12 flex">
            <p-inputSwitch [(ngModel)]="product.taxable"></p-inputSwitch>
            <div class="label">
                {{ 'bikeshop.products.taxable' | translate }}
            </div>
        </div>
    </div>

</div>
<div class="modal-footer-container">
    <div class="button-container">
        <hub-button [text]="'bikeshop.modal.update_job_card.quote.create_inventory_item' | translate"
            [style]="'secondary'" [size]="'xl'" (buttonClick)="save()" [disabled]="!valid() || saving" [loading]="saving"></hub-button>
    </div>
    <div class="short-cut-container">
        <span><daz-icon [name]="'enter'" [size]="'18px'"
                [color]="'#6B728C'"></daz-icon></span>{{'bikeshop.workshop.jobcard.quote.to_save_and_close' |
        translate}}
    </div>
</div>
<p-confirmDialog key="delete-collection-dialog"></p-confirmDialog>